module.exports = __webpack_public_path__ + "img/en-GB-add-to-apple-wallet.7850a4e.svg";